import { mockKolMetricPerformanceData } from '@/constants/kol-detail/metric-performance'
import { Potential } from '@/utils/detail/potential'

export const mockKolInfoKpi = {
  fansUpRate3m: 0.357,
  follower: 109586,
  fansUpRateCount3m: 28830,
  potential: Potential.High,
  avgLike6m: 145990,
  avgComment6m: 80090,
  ...mockKolMetricPerformanceData.yt,
}
